import axios from "axios";
import * as echarts from "echarts";
let showChart;

//按需加载
//import {} from "../../../../api/api";

export default {
  components: {},
  data() {
    return {
      bimMonitorItemData_show: true,
      isFold: false,
      activeIndex: 0,
      firstRangeInterval: [], //线型监测（多个断面展示）初始视图的起始监测点索引和结束监测点索引。
      m2nodesCount_1: 0, //线型监测（多个断面展示）总的监测点数量。
      secondRangeInterval: [], //应力监测初始视图的起始监测点索引和结束监测点索引。
      m2nodesCount_2: 0, //应力监测总的监测点数量。
      showTemplate: 0, // 监测管理主弹窗组件传进来的展示模板字符。
      chartData: [], // 监测管理主弹窗组件传进来的点击项的数据。
    };
  },
  mounted() {
    //alert(this.showTemplate)
    // this.showInfo1();
  },
  watch: {
    showTemplate(newVal, oldVal) {},
  },
  methods: {
    initData(showTemplateVal, chartData) {
      this.showTemplate = showTemplateVal;
      this.chartData = chartData;
      //console.log(JSON.parse(JSON.stringify(this.chartData)));
      //console.log(222);
      // console.log(showTemplateVal);
      switch (showTemplateVal) {
        case 1: // 线型监测。
          this.activeIndex = 1;
          this.$nextTick((res) => {
            this.showInfo1();
          });
          break;
        case 2: // 线型监测 多断面展示。
          this.activeIndex = 4;
          this.$nextTick((res) => {
            this.firstRangeInterval = [0, 5];
            this.m2nodesCount_1 =
              this.chartData[1].length > 0 ? this.chartData[1].length : 0;
            this.showInfo4();
          });
          break;
        case 3: // 应力监测。
          this.activeIndex = 5;
          this.$nextTick((res) => {
            this.secondRangeInterval = [0, 5];
            this.m2nodesCount_2 =
              this.chartData[1].length > 0 ? this.chartData[1].length : 0;
            this.showInfo5();
          });
          break;
        case 4: // 沉降监测。
          this.activeIndex = 7;
          this.$nextTick((res) => {
            this.showInfo7();
          });
          break;
        case 5: // 竖向、横向、水平监测。
          this.activeIndex = 8;
          this.$nextTick((res) => {
            this.showInfo8();
          });
          break;
        default:
          break;
      }
    },
    // deleteRow(index) {
    // 	console.log(index+'触发1');
    // 	console.log(this.bimMonitorItemData_data[3]['color']);
    // 	console.log(this.bimMonitorItemData_data[3]['show']);
    // },
    bimMonitorItemData_click() {
      //this.bimMonitorItemData_show=false;
      //alert("触发");
      this.$emit("bimMonitorItemData_close");
    },

    //画图表
    showInfo1() {
      let that = this;
      this.activeIndex = 1;
      if (showChart) {
        showChart.dispose(); // 如果已存在，则先释放再重新生成，避免内存泄漏。
      }
      // 基于准备好的dom，初始化echarts实例
      showChart = echarts.init(document.getElementById("showCharts"), "dark");
      // 绘制图表

      // console.log(JSON.parse(JSON.stringify(this.chartData)));
      // console.log(33);
      if (this.chartData && this.chartData[0] && this.chartData[0].length > 0) {
        let xArr = [];
        this.chartData[0].forEach((item) => {
          if (item.name === that.chartData[2][0].name) {
            xArr.push(item.name + "(当前观测点)");
          } else {
            xArr.push(item.name);
          }
          item.value = item.diffValue;
        });
        // console.log(xArr);
        // console.log(JSON.parse(JSON.stringify(this.chartData)));

        showChart.setOption({
          title: {
            text:
              "长山河特大桥-" +
              that.chartData[2][0].name +
              "-线性监测" +
              "（浇筑混凝土后）",
            left: "center",
            top: 10,
            textStyle: {
              fontSize: 14,
            },
          },
          tooltip: {
            trigger: "axis",
            textStyle: {
              color: "#333",
            },
            axisPointer: {
              label: {
                backgroundColor: "#f03752",
              },
            },
            showDelay: 100,
            formatter: function(params) {
              let tempStr = "<b>" + params[0].name + "</b>";
              if (params[0].data.name === that.chartData[2][0].name) {
                tempStr += "(当前观测点)";
              }
              tempStr +=
                "<br>偏差值(m)： " +
                params[0].data.value +
                "<br>标高理论值(m)： " +
                params[0].data.theoreticalValue +
                "<br>标高实测值(m)：" +
                params[0].data.actualValue;
              return tempStr;
            },
          },
          legend: {
            tooltip: {
              show: true,
            },
            top: 36,
          },
          grid: {
            top: 90,
            left: "12%",
          },
          xAxis: {
            name: "位置",
            type: "category",
            boundaryGap: false,
            data: xArr,
            splitLine: {
              show: true,
            },
          },
          yAxis: {
            name: "偏差值（m）",
            type: "value",
            scale: true,
            axisLine: {
              show: true,
            },
            splitLine: {
              show: true,
            },
          },
          series: [
            {
              data: this.chartData[0],
              name: "偏差值（m)",
              icon: "circle", // 图例的图标样式
              type: "line",
              smooth: true,

              showSymbol: true, //是否默认展示圆点
              symbol: "circle", //设定为实心点
              symbolSize: 12, //设定实心点的大小
              itemStyle: {
                normal: {
                  color: "#fbf2e3", //改变折线点的颜色
                },
              },
              lineStyle: {
                width: 3, //设置折线宽度
                color: "#f03752", //改变折线颜色
              },
            },
          ],
        });
      } else {
        this.$message({
          message:
            "暂未查询到" +
            this.chartData[2][0].name +
            " 的工况（浇筑混凝土后）监测数据。",
          type: "error",
          offset: 100,
          showClose: true,
          duration: 1600,
        });
      }
    },
    showInfo2() {
      let that = this;
      this.activeIndex = 2;
      if (showChart) {
        showChart.dispose(); // 如果已存在，则先释放再重新生成，避免内存泄漏。
      }
      // 基于准备好的dom，初始化echarts实例
      showChart = echarts.init(document.getElementById("showCharts"), "dark");
      // 绘制图表
      if (this.chartData && this.chartData[1] && this.chartData[1].length > 0) {
        let xArr = [];
        this.chartData[1].forEach((item) => {
          if (item.name === that.chartData[2][0].name) {
            xArr.push(item.name + "(当前观测点)");
          } else {
            xArr.push(item.name);
          }
          item.value = item.diffValue;
        });
        showChart.setOption({
          title: {
            text:
              "长山河特大桥-" +
              that.chartData[2][0].name +
              "-线性监测" +
              "（预应力张拉后）",
            left: "center",
            top: 10,
            textStyle: {
              fontSize: 14,
            },
          },
          tooltip: {
            trigger: "axis",
            textStyle: {
              color: "#333",
            },
            axisPointer: {
              label: {
                backgroundColor: "#f03752",
              },
            },
            showDelay: 100,
            formatter: function(params) {
              let tempStr = "<b>" + params[0].name + "</b>";
              if (params[0].data.name === that.chartData[2][0].name) {
                tempStr += "(当前观测点)";
              }
              tempStr +=
                "<br>偏差值(m)： " +
                params[0].data.value +
                "<br>标高理论值(m)： " +
                params[0].data.theoreticalValue +
                "<br>标高实测值(m)：" +
                params[0].data.actualValue;
              return tempStr;
            },
          },
          legend: {
            tooltip: {
              show: true,
            },
            top: 36,
          },
          grid: {
            top: 90,
            left: "12%",
          },
          xAxis: {
            name: "位置",
            type: "category",
            boundaryGap: false,
            data: xArr,
            splitLine: {
              show: true,
            },
          },
          yAxis: {
            name: "偏差值（m）",
            type: "value",
            scale: true,
            axisLine: {
              show: true,
            },
            splitLine: {
              show: true,
            },
          },
          series: [
            {
              data: this.chartData[1],
              name: "偏差值（m)",
              icon: "circle", // 图例的图标样式
              type: "line",
              smooth: true,

              showSymbol: true, //是否默认展示圆点
              symbol: "circle", //设定为实心点
              symbolSize: 12, //设定实心点的大小
              itemStyle: {
                normal: {
                  color: "#fbf2e3", //改变折线点的颜色
                },
              },
              lineStyle: {
                width: 3, //设置折线宽度
                color: "#f03752", //改变折线颜色
              },
            },
          ],
        });
      } else {
        this.$message({
          message:
            "暂未查询到" +
            this.chartData[2][0].name +
            " 的工况（预应力张拉后）监测数据。",
          type: "error",
          offset: 100,
          showClose: true,
          duration: 1600,
        });
      }
    },
    showInfo3() {
      let that = this;
      this.activeIndex = 3;
      if (showChart) {
        showChart.dispose(); // 如果已存在，则先释放再重新生成，避免内存泄漏。
      }
      // 基于准备好的dom，初始化echarts实例
      showChart = echarts.init(document.getElementById("showCharts"), "dark");
      // 绘制图表
      if (this.chartData && this.chartData[2] && this.chartData[2].length > 0) {
        let xArr = ["浇筑混凝土后", "预应力张拉后"];
        this.chartData[2].forEach((item) => {
          item.value = item.diffValue;
        });
        showChart.setOption({
          title: {
            text: "长山河特大桥-" + that.chartData[2][0].name + "-线性监测",
            left: "center",
            top: 10,
            textStyle: {
              fontSize: 14,
            },
          },
          tooltip: {
            trigger: "axis",
            textStyle: {
              color: "#333",
            },
            axisPointer: {
              label: {
                backgroundColor: "#f03752",
              },
            },
            showDelay: 100,
            formatter: function(params) {
              let tempStr = "<b>" + params[0].name + "</b>";
              if (params[0].data.type === 0) {
                tempStr += "（浇筑混凝土后）";
              } else {
                tempStr += "（预应力张拉后）";
              }
              tempStr +=
                "<br>偏差值(m)： " +
                params[0].data.value +
                "<br>标高理论值(m)： " +
                params[0].data.theoreticalValue +
                "<br>标高实测值(m)：" +
                params[0].data.actualValue;
              return tempStr;
            },
          },
          grid: {
            top: 100,
            left: "12%",
          },
          legend: {
            tooltip: {
              show: true,
            },
            top: 36,
          },
          xAxis: {
            name: "位置",
            type: "category",
            splitArea: {
              show: true,
            },
            data: xArr,
            splitLine: {
              show: true,
            },
          },
          yAxis: {
            name: "偏差值（m）",
            type: "value",
            scale: true,
            axisLine: {
              show: true,
            },
            splitLine: {
              show: true,
            },
          },
          series: [
            {
              data: this.chartData[2],
              name: "偏差值（m)",
              icon: "circle", // 图例的图标样式
              type: "line",
              smooth: true,

              showSymbol: true, //是否默认展示圆点
              symbol: "circle", //设定为实心点
              symbolSize: 12, //设定实心点的大小
              itemStyle: {
                normal: {
                  color: "#fbf2e3", //改变折线点的颜色
                },
              },
              lineStyle: {
                width: 3, //设置折线宽度
                color: "#f03752", //改变折线颜色
              },
            },
          ],
        });
      } else {
        this.$message({
          message:
            "暂未查询到" + this.chartData[2][0].name + " 对应的监测数据。",
          type: "error",
          offset: 100,
          showClose: true,
          duration: 1600,
        });
      }
    },
    //线型监测，多个断面展示。
    showInfo4() {
      let that = this;
      this.activeIndex = 4;
      if (showChart) {
        showChart.dispose(); // 如果已存在，则先释放再重新生成，避免内存泄漏。
      }
      // 基于准备好的dom，初始化echarts实例
      showChart = echarts.init(document.getElementById("showCharts"), "dark");
      // 绘制图表

      if (this.chartData && this.chartData[1] && this.chartData[1].length > 0) {
        // 根据范围滑块起始值和结束值来裁剪数组。
        let showData = this.chartData[1].slice(
          this.firstRangeInterval[0],
          this.firstRangeInterval[1]
        );
        let xArr = [];
        showData.forEach((item) => {
          // if(item.name===that.chartData[0].name){
          // 	xArr.push(item.name+'(当前观测点)');
          // }else{
          // 	xArr.push(item.name);
          // }
          xArr.push(item.name);
          item.value = item.diffValue;
        });
        // console.log(JSON.parse(JSON.stringify(this.firstRangeInterval)));
        // console.log(JSON.parse(JSON.stringify(showData)));
        //console.log(JSON.parse(JSON.stringify(this.chartData)));
        // console.log(JSON.parse(JSON.stringify(xArr)));
        // console.log(123);
        showChart.setOption({
          title: {
            text: "长山河特大桥-" + that.chartData[0].name + "-监测点线型监测",
            left: "center",
            top: 10,
            textStyle: {
              fontSize: 14,
            },
          },
          tooltip: {
            trigger: "axis",
            textStyle: {
              color: "#333",
            },
            axisPointer: {
              label: {
                backgroundColor: "#f03752",
              },
            },
            showDelay: 100,
            formatter: function(params) {
              let tempStr = "<b>" + params[0].name + "</b>";
              tempStr +=
                "<br>偏差值(m)： " +
                params[0].data.value +
                "<br>理论值(m)： " +
                params[0].data.theoreticalValue +
                "<br>实测值(m)：" +
                params[0].data.actualValue;
              return tempStr;
            },
          },
          legend: {
            tooltip: {
              show: true,
            },
            top: 36,
          },
          grid: {
            top: 90,
            left: "12%",
          },
          xAxis: {
            name: "监测点",
            type: "category",
            boundaryGap: false,
            data: xArr,
            splitLine: {
              show: true,
              //interval: 1,//不需要间隔一个，让echarts图表自动决定如何省略。
            },
          },
          yAxis: {
            name: "偏差值（m）",
            type: "value",
            scale: true,
            axisLine: {
              show: true,
            },
            splitLine: {
              show: true,
            },
          },
          series: [
            {
              data: showData,
              name: "偏差值（m)",
              icon: "circle", // 图例的图标样式
              type: "line",
              smooth: true,

              showSymbol: true, //是否默认展示圆点
              symbol: "circle", //设定为实心点
              symbolSize: 12, //设定实心点的大小
              itemStyle: {
                normal: {
                  color: "#fbf2e3", //改变折线点的颜色
                },
              },
              lineStyle: {
                width: 3, //设置折线宽度
                color: "#f03752", //改变折线颜色
              },
            },
          ],
        });
      } else {
        this.$message({
          message:
            "暂未查询到" + that.chartData[0].name + " 下各监测点的监测数据。",
          type: "error",
          offset: 100,
          showClose: true,
          duration: 1600,
        });
      }
    },
    //顶板纵向 监测
    showInfo5() {
      let that = this;
      this.activeIndex = 5;
      if (showChart) {
        showChart.dispose(); // 如果已存在，则先释放再重新生成，避免内存泄漏。
      }
      // 基于准备好的dom，初始化echarts实例
      showChart = echarts.init(document.getElementById("showCharts"), "dark");
      // 绘制图表
      if (this.chartData && this.chartData[1] && this.chartData[1].length > 0) {
        // 根据范围滑块起始值和结束值来裁剪数组。
        let showData = this.chartData[1].slice(
          this.secondRangeInterval[0],
          this.secondRangeInterval[1]
        );
        let xArr = [];
        showData.forEach((item) => {
          // if(item.name===that.chartData[0].name){
          // 	xArr.push(item.name+'(当前观测点)');
          // }else{
          // 	xArr.push(item.name);
          // }
          xArr.push(item.name);
          item.value = item.diffValue;
        });
        showChart.setOption({
          title: {
            text: "长山河特大桥-" + that.chartData[0].name + "-应力监测",
            left: "center",
            top: 10,
            textStyle: {
              fontSize: 14,
            },
          },
          tooltip: {
            trigger: "axis",
            textStyle: {
              color: "#333",
            },
            axisPointer: {
              label: {
                backgroundColor: "#f03752",
              },
            },
            showDelay: 100,
            formatter: function(params) {
              let tempStr = "<b>" + params[0].name + "</b>";
              tempStr +=
                "<br>偏差值(MPa)： " +
                params[0].data.value +
                "<br>理论值(MPa)： " +
                params[0].data.theoreticalValue +
                "<br>实测平均值(MPa)：" +
                params[0].data.actualValue;
              return tempStr;
            },
          },
          legend: {
            tooltip: {
              show: true,
            },
            top: 36,
          },
          grid: {
            top: 90,
            left: "12%",
          },
          xAxis: {
            name: "工况",
            type: "category",
            boundaryGap: false,
            data: xArr,
            splitLine: {
              show: true,
              //interval: 1,
            },
          },
          yAxis: {
            name: "偏差值（MPa）",
            type: "value",
            scale: true,
            axisLine: {
              show: true,
            },
            splitLine: {
              show: true,
            },
          },
          series: [
            {
              data: showData,
              name: "偏差值（MPa)",
              icon: "circle", // 图例的图标样式
              type: "line",
              smooth: true,

              showSymbol: true, //是否默认展示圆点
              symbol: "circle", //设定为实心点
              symbolSize: 12, //设定实心点的大小
              itemStyle: {
                normal: {
                  color: "#fbf2e3", //改变折线点的颜色
                },
              },
              lineStyle: {
                width: 3, //设置折线宽度
                color: "#f03752", //改变折线颜色
              },
            },
          ],
        });
      } else {
        this.$message({
          message:
            "暂未查询到 " +
            that.chartData[0].name +
            " 的顶板纵向应力监测数据。",
          type: "error",
          offset: 100,
          showClose: true,
          duration: 1600,
        });
      }
    },
    //底板纵向 监测
    showInfo6() {
      let that = this;
      this.activeIndex = 6;
      if (showChart) {
        showChart.dispose(); // 如果已存在，则先释放再重新生成，避免内存泄漏。
      }
      // 基于准备好的dom，初始化echarts实例
      showChart = echarts.init(document.getElementById("showCharts"), "dark");
      // 绘制图表
      if (this.chartData && this.chartData[2] && this.chartData[2].length > 0) {
        // 根据范围滑块起始值和结束值来裁剪数组。
        let showData = this.chartData[2].slice(
          this.secondRangeInterval[0],
          this.secondRangeInterval[1]
        );
        let xArr = [];
        showData.forEach((item) => {
          // if(item.name===that.chartData[0].name){
          // 	xArr.push(item.name+'(当前观测点)');
          // }else{
          // 	xArr.push(item.name);
          // }
          xArr.push(item.name);
          item.value = item.diffValue;
        });
        showChart.setOption({
          title: {
            text: "长山河特大桥-" + that.chartData[0].name + "-应力监测",
            left: "center",
            top: 10,
            textStyle: {
              fontSize: 14,
            },
          },
          tooltip: {
            trigger: "axis",
            textStyle: {
              color: "#333",
            },
            axisPointer: {
              label: {
                backgroundColor: "#f03752",
              },
            },
            showDelay: 100,
            formatter: function(params) {
              let tempStr = "<b>" + params[0].name + "</b>";
              tempStr +=
                "<br>偏差值(MPa)： " +
                params[0].data.value +
                "<br>理论值(MPa)： " +
                params[0].data.theoreticalValue +
                "<br>实测平均值(MPa)：" +
                params[0].data.actualValue;
              return tempStr;
            },
          },
          legend: {
            tooltip: {
              show: true,
            },
            top: 36,
          },
          grid: {
            top: 90,
            left: "12%",
          },
          xAxis: {
            name: "工况",
            type: "category",
            boundaryGap: false,
            data: xArr,
            splitLine: {
              show: true,
              //interval: 1,
            },
          },
          yAxis: {
            name: "偏差值（MPa）",
            type: "value",
            scale: true,
            axisLine: {
              show: true,
            },
            splitLine: {
              show: true,
            },
          },
          series: [
            {
              data: showData,
              name: "偏差值（MPa)",
              icon: "circle", // 图例的图标样式
              type: "line",
              smooth: true,

              showSymbol: true, //是否默认展示圆点
              symbol: "circle", //设定为实心点
              symbolSize: 12, //设定实心点的大小
              itemStyle: {
                normal: {
                  color: "#fbf2e3", //改变折线点的颜色
                },
              },
              lineStyle: {
                width: 3, //设置折线宽度
                color: "#f03752", //改变折线颜色
              },
            },
          ],
        });
      } else {
        this.$message({
          message:
            "暂未查询到 " +
            that.chartData[0].name +
            " 的底板纵向应力监测数据。",
          type: "error",
          offset: 100,
          showClose: true,
          duration: 1600,
        });
      }
    },
    //基础沉降 监测
    showInfo7() {
      let that = this;
      this.activeIndex = 7;
      if (showChart) {
        showChart.dispose(); // 如果已存在，则先释放再重新生成，避免内存泄漏。
      }
      // 基于准备好的dom，初始化echarts实例
      showChart = echarts.init(document.getElementById("showCharts"), "dark");
      // 绘制图表
      if (this.chartData && this.chartData[1] && this.chartData[1].length > 0) {
        let xArr = [];
        this.chartData[1].forEach((item) => {
          // if(item.name===that.chartData[0].name){
          // 	xArr.push(item.name+'(当前观测点)');
          // }else{
          // 	xArr.push(item.name);
          // }
          xArr.push(item.name);
          item.value = item.diffValue;
        });
        showChart.setOption({
          title: {
            text: "长山河特大桥-" + that.chartData[0].name + "-基础沉降监测",
            left: "center",
            top: 10,
            textStyle: {
              fontSize: 14,
            },
          },
          tooltip: {
            trigger: "axis",
            textStyle: {
              color: "#333",
            },
            axisPointer: {
              label: {
                backgroundColor: "#f03752",
              },
            },
            showDelay: 100,
            formatter: function(params) {
              let tempStr = "<b>" + params[0].name + "</b>";
              tempStr +=
                "<br>偏差值(mm)： " +
                params[0].data.value +
                "<br>初始值监测修正值(m)： " +
                params[0].data.theoreticalValue +
                "<br>现阶段监测值(m)：" +
                params[0].data.actualValue;
              return tempStr;
            },
          },
          legend: {
            tooltip: {
              show: true,
            },
            top: 36,
          },
          grid: {
            top: 90,
            left: "10%",
            right: "12.6%",
          },
          xAxis: {
            name: "点编号",
            type: "category",
            boundaryGap: false,
            data: xArr,
            splitLine: {
              show: true,
              //interval: 1,
            },
          },
          yAxis: {
            name: "偏差值（mm）",
            type: "value",
            scale: true,
            axisLine: {
              show: true,
            },
            splitLine: {
              show: true,
            },
          },
          series: [
            {
              data: this.chartData[1],
              name: "偏差值（mm)",
              icon: "circle", // 图例的图标样式
              type: "line",
              smooth: true,

              showSymbol: true, //是否默认展示圆点
              symbol: "circle", //设定为实心点
              symbolSize: 12, //设定实心点的大小
              itemStyle: {
                normal: {
                  color: "#fbf2e3", //改变折线点的颜色
                },
              },
              lineStyle: {
                width: 3, //设置折线宽度
                color: "#f03752", //改变折线颜色
              },
            },
          ],
        });
      } else {
        this.$message({
          message:
            "暂未查询到" + that.chartData[0].name + " 的基础沉降监测数据。",
          type: "error",
          offset: 100,
          showClose: true,
          duration: 1600,
        });
      }
    },
    //竖向位移 监测
    showInfo8() {
      let that = this;
      this.activeIndex = 8;
      if (showChart) {
        showChart.dispose(); // 如果已存在，则先释放再重新生成，避免内存泄漏。
      }
      // 基于准备好的dom，初始化echarts实例
      showChart = echarts.init(document.getElementById("showCharts"), "dark");
      // 绘制图表
      if (
        this.chartData &&
        this.chartData[1] &&
        this.chartData[1][0] &&
        this.chartData[1][0].length > 0
      ) {
        let legendArr = [];
        let xArr = [];
        this.chartData[1][0].forEach((item) => {
          legendArr.push(item.name);
          item.value = item.displacementValue;

          // 因为横坐标是一致的，所以只遍历一次获取到xArr。
          if (legendArr.length === 1) {
            item.dataArr.map((item2) => {
              xArr.push(item2.date);
            });
          }
        });
        showChart.setOption({
          title: {
            text: "K(ZK)135+400~K(ZK)136+100-高路堤-竖向位移",
            left: "center",
            top: 10,
            textStyle: {
              fontSize: 14,
            },
          },
          tooltip: {
            trigger: "axis",
          },
          legend: {
            orient: "vertical",
            right: 6,
            top: "middle",
            data: legendArr,
          },
          grid: {
            left: "4%",
            right: 160,
            bottom: "3%",
            containLabel: true,
          },
          // toolbox: {
          // 	feature: {
          // 		saveAsImage: {}
          // 	}
          // },
          xAxis: {
            name: "日期",
            type: "category",
            boundaryGap: false,
            data: xArr,
            splitLine: {
              show: true,
            },
          },
          yAxis: {
            name: "竖向位移(mm)",
            type: "value",
            splitLine: {
              show: true,
            },
          },
          series: this.chartData[1][0],
        });
      } else {
        this.$message({
          message: "暂未查询到该项的竖向位移监测数据。",
          type: "error",
          offset: 100,
          showClose: true,
          duration: 1600,
        });
      }
    },
    //横向位移 监测
    showInfo9() {
      let that = this;
      this.activeIndex = 9;
      if (showChart) {
        showChart.dispose(); // 如果已存在，则先释放再重新生成，避免内存泄漏。
      }
      // 基于准备好的dom，初始化echarts实例
      showChart = echarts.init(document.getElementById("showCharts"), "dark");
      // 绘制图表
      if (
        this.chartData &&
        this.chartData[1] &&
        this.chartData[1][1] &&
        this.chartData[1][1].length > 0
      ) {
        let legendArr = [];
        let xArr = [];
        this.chartData[1][1].forEach((item) => {
          legendArr.push(item.name);
          item.value = item.displacementValue;

          // 因为横坐标是一致的，所以只遍历一次获取到xArr。
          if (legendArr.length === 1) {
            item.dataArr.map((item2) => {
              xArr.push(item2.date);
            });
          }
        });
        showChart.setOption({
          title: {
            text: "K(ZK)135+400~K(ZK)136+100-高路堤-横向位移",
            left: "center",
            top: 10,
            textStyle: {
              fontSize: 14,
            },
          },
          tooltip: {
            trigger: "axis",
          },
          legend: {
            orient: "vertical",
            right: 6,
            top: "middle",
            data: legendArr,
          },
          grid: {
            left: "4%",
            right: 160,
            bottom: "3%",
            containLabel: true,
          },
          // toolbox: {
          // 	feature: {
          // 		saveAsImage: {}
          // 	}
          // },
          xAxis: {
            name: "日期",
            type: "category",
            boundaryGap: false,
            data: xArr,
            splitLine: {
              show: true,
            },
          },
          yAxis: {
            name: "横向位移(mm)",
            type: "value",
            splitLine: {
              show: true,
            },
          },
          series: this.chartData[1][1],
        });
      } else {
        this.$message({
          message: "暂未查询到该项的横向位移监测数据。",
          type: "error",
          offset: 100,
          showClose: true,
          duration: 1600,
        });
      }
    },
    //水平位移 监测
    showInfo10() {
      let that = this;
      this.activeIndex = 10;
      if (showChart) {
        showChart.dispose(); // 如果已存在，则先释放再重新生成，避免内存泄漏。
      }
      // 基于准备好的dom，初始化echarts实例
      showChart = echarts.init(document.getElementById("showCharts"), "dark");
      // 绘制图表
      if (
        this.chartData &&
        this.chartData[1] &&
        this.chartData[1][2] &&
        this.chartData[1][2].length > 0
      ) {
        let legendArr = [];
        let xArr = [];
        this.chartData[1][2].forEach((item) => {
          legendArr.push(item.name);
          item.value = item.displacementValue;

          // 因为横坐标是一致的，所以只遍历一次获取到xArr。
          if (legendArr.length === 1) {
            item.dataArr.map((item2) => {
              xArr.push(item2.date);
            });
          }
        });
        showChart.setOption({
          title: {
            text: "K(ZK)135+400~K(ZK)136+100-高路堤-水平位移",
            left: "center",
            top: 10,
            textStyle: {
              fontSize: 14,
            },
          },
          tooltip: {
            trigger: "axis",
          },
          legend: {
            orient: "vertical",
            right: 6,
            top: "middle",
            data: legendArr,
          },
          grid: {
            left: "4%",
            right: 160,
            bottom: "3%",
            containLabel: true,
          },
          // toolbox: {
          // 	feature: {
          // 		saveAsImage: {}
          // 	}
          // },
          xAxis: {
            name: "日期",
            type: "category",
            boundaryGap: false,
            data: xArr,
            splitLine: {
              show: true,
            },
          },
          yAxis: {
            name: "水平位移(mm)",
            type: "value",
            splitLine: {
              show: true,
            },
          },
          series: this.chartData[1][2],
        });
      } else {
        this.$message({
          message: "暂未查询到该项的水平位移监测数据。",
          type: "error",
          offset: 100,
          showClose: true,
          duration: 1600,
        });
      }
    },
    verifyIndex(index) {
      return this.activeIndex === index ? true : false;
    },
    changeFirstRange(item) {
      // console.log(JSON.parse(JSON.stringify(this.chartData)));
      // console.log(789);
      this.showInfo4();
    },
    changeSecondRange(item) {
      if (this.activeIndex === 5) {
        this.showInfo5();
      } else {
        this.showInfo6();
      }
    },
  },
  watch: {},
  destroyed() {
    if (showChart) {
      showChart.dispose(); // 如果存在，则释放，避免内存泄漏。
    }
  },
};
//console.log(localStorage.getItem(ColorPicker));
